import {memo, type ReactElement} from 'react'
import {useVisitCollection, useVisitFilterFromCurrentUser} from '../../../hooks/entity/useVisit'
import {getSpotUrl} from '../../../hooks/useSpotNavigate'
import {useLogged} from '../../../states/auth'
import {SpotList} from './SpotList'

interface Props {
  fallback?: ReactElement
}

export const SpotLastList = memo(({fallback}: Props) => {
  const logged = useLogged()
  const {visits} = useVisitCollection({...useVisitFilterFromCurrentUser(), stared: true})

  if (false === logged) {
    return fallback ?? null
  }

  if (!visits || visits.member.length === 0) {
    return fallback ?? null
  }

  return <SpotList
    spotIris={visits.member.map((visit) => visit.spot)}
    linkPattern={getSpotUrl('{spotSlug}')}
    limit={6}
  />
})
